import DescriptionIcon from "@mui/icons-material/DescriptionOutlined";

const CommentaryPDFButton = ({ assignment, showCommentaryPDF }) => {
  return (
    <button
      onClick={() => showCommentaryPDF(assignment)}
      style={{
        width: "34px",
        height: "34px",
        backgroundColor: "#FFF",
        border: "1.5px solid #E6EDEC",
        borderRadius: "10px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        transition: "border-color .12s, color .12s",
        color: "#3A434E",
      }}
      title="문서 열기"
      onMouseEnter={(e) => {
        e.currentTarget.style.borderColor = "#00D9C0";
        e.currentTarget.style.color = "#00A396";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.borderColor = "#E6EDEC";
        e.currentTarget.style.color = "#3A434E";
      }}
    >
      <DescriptionIcon style={{ fontSize: "20px" }} />
    </button>
  );
};

export default CommentaryPDFButton;
